module.exports = __webpack_public_path__ + "img/pdf_icon_2.d3dbf517.svg";